module.exports = __webpack_public_path__ + "assets/trackjs.5fbc23f5.svg";